import $ from 'jquery';
import _ from 'lodash';
import module from 'module';
import {NgTableParams} from 'ng-table/ng-table.js';
import '../../common/modal/modal-info.component'

const templateUrl = require('./pawned-items-list.template.html');
module.component('pawnedItemsList', {
  templateUrl: templateUrl,
  controller: function ($scope, $routeParams, $location, $filter, $route, http,
                        authentication, notification, confirmation, branchService, pawnCache, popup,
                        pawnItemTypeCache, pawnItemDefectTypeCache, pawnMetalRateCache, pawnAuctionCache,
                        pawnItemAttributeTypeCache, pawnMetalTypesCache, command, pawnService, pawnMetalDescriptionService,
                        modalInfo, pawnStatusMapper, pawnItemCache, systemPropertyCache) {
    let that = this;

    that.pawnStatusMapper = pawnStatusMapper;
    that.systemPropertyCache = systemPropertyCache;

    const reportCode = 'PawnedItemsInventory';

    that.params = {};
    that.selectedColumns = [];

    that.metals = [];

    that.pawnItemTypes = [];
    that.pawnItemDefectTypes = [];
    that.pawnMetalRates = [];
    that.pawnItemAttributeTypes = [];


    that.checkedForCalculateAuctionPrice = [];
    that.chkCalculateAuctionPriceAll = false;

    that.checkedForWithdraw = [];
    that.chkSellAll = false;
    that.chkWithdrawAll = false;

    that.checkedForMoveToStock = [];
    that.chkMoveToStockAll = false;

    that.result = [];
    that.criteria = {
      category: null,
      type: null,
      defect: null,
      branch: null
    };

    that.filterConfig = {
      reportCode: reportCode,
      buttons: {
        filter: {
          isVisible: true,
          isDisabled: false,
          action: () => that.filter(),
          text: 'Filter'
        }, download: {
          isVisible: true,
          isDisabled: false,
          action: () => that.downloadXls(),
          text: 'Download xls'
        }, print: {
          isVisible: false,
          isDisabled: false,
          action: null,
          text: 'Print'
        }
      }
    };

    that.$onInit = async () => {
      const properties = await that.systemPropertyCache.toPromise();
      const auctionTaggingEnabled = _.find(properties, {code: 'AUCTION_TAGGING_ENABLED'});
      that.auctionTaggingEnabled = auctionTaggingEnabled && auctionTaggingEnabled.value === 'TRUE';
      const hideValuationColumn = _.find(properties, {code: 'PAWNED_ITEMS_HIDE_VALUATION_COLUMN'});
      that.hideValuationColumn = hideValuationColumn && hideValuationColumn.value === 'TRUE';
    }

    branchService.toObservable().subscribe(branches => {
      that.branches = branches;
    });

    pawnAuctionCache.systemAuctions().toObservable().subscribe(auctions => {
      that.auctions = auctions;
    });

    // Read pawn meta types
    pawnMetalTypesCache.toObservable().subscribe(types => that.metals = types);

    // Read pawn item types
    pawnItemTypeCache.toObservable().subscribe(itemTypes => {
      that.pawnItemTypes = itemTypes;
    });

    // Read pawn item defect types
    pawnItemDefectTypeCache.toObservable().subscribe(defectTypes => {
      that.pawnItemDefectTypes = defectTypes;
    });

    // Read pawn metal rates
    pawnMetalRateCache.toObservable().subscribe(rates => {
      that.pawnMetalRates = rates;
    });

    // Read pawn item attributes types
    pawnItemAttributeTypeCache.toObservable().subscribe(attributeTypes => {
      that.pawnItemAttributeTypes = attributeTypes;
    });


    that.getTypeLabel = (typeId) => {
      let type = _.find(that.pawnItemTypes, {id: typeId});
      return type && type.name ? type.name : '-';
    };

    that.filter = () => {
      that.result = [];
      that.checkedForCalculateAuctionPrice = [];
      that.checkedForWithdraw = [];
      that.checkedForMoveToStock = [];
      // go back to first page when data is reloaded
      that.tableConfig.page(1);
      that.tableConfig.reload();
    };

    that.downloadXls = () => {
      http.http({
        url: `/reports/${reportCode}/xls`,
        method: 'POST',
        responseType: 'blob',
        data: $.param(that.params),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        nxLoaderText: 'Downloading report XLS'
      }).success(response => {
        const xlsxFileUrl = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = xlsxFileUrl;
        a.download = `Pawned_Items_Report.xlsx`;
        a.click();
        window.URL.revokeObjectURL(xlsxFileUrl);
      });
    };


    // Call service for default filter config
    that.tableConfig = new NgTableParams({
      count: 15,
    }, {
      counts: [],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 3,
      getData: params => {
        that.currentBranchId = that.params.branchId || null;
        that.selectedAuctionIds = that.getSelectedAuctionIds();

        let typeIds = that.params.pawnItemTypeId;
        // selecting all types should only include those with parentId
        // that is equal to the selected categoryId
        if (that.params.pawnItemCategoryId && !_.first(typeIds)) {
          typeIds = that.pawnItemTypes
            .filter((type) => type.parentId === that.params.pawnItemCategoryId)
            .map((type) => type.id);
        }

        const queryParams = {
          pageNo: params.page() - 1,
          pageSize: params.count(),
          inStock: false,
          categoryId: that.params.pawnItemCategoryId || null,
          typeIds: typeIds,
          productStatus: that.params['productStatus[]'],
          branchIds: that.currentBranchId,
          auctionIds: that.selectedAuctionIds,
          trackingCode: that.params.trackingCode || null,
          ticketNumber: that.params.pawnTicketNumber || null,
          tagIds: that.params['pawnTagId[]'],
          productGroup: 'PAWN'
        };

        that.selectedColumns = that.params["columns_array[]"].filter(item => item);
        const showAll = that.selectedColumns.length === 0;
        that.showValuationColumn = !that.hideValuationColumn && (showAll || that.selectedColumns.includes('valuation'));
        that.showCostColumn = showAll || that.selectedColumns.includes('cost') || (that.hideValuationColumn && that.selectedColumns.includes('valuation'));

        // Create pawn items search promise
        return http.get(`/products/pawns/items?${$.param(queryParams, true)}`, {nxLoaderText: 'Loading pawn items'})
          .success((response) => {
            that.chkCalculateAuctionPriceAll = false;
            that.chkWithdrawAll = false;
            that.chkSellAll = false;
            that.chkMoveToStockAll = false;

            that.result = response.result;
            that.tableConfig.data = that.result;
            that.tableConfig.total(response.totalCount);

            // For each pawn item prepare item details
            if (that.result && that.result.length > 0) {
              _.forEach(that.result, (obj) => {
                //Set withdraw for pawn item if was selected
                obj.item.withdraw = _.findIndex(that.checkedForWithdraw, {id: obj.item.id}) > -1;

                //Set "calculate auction price" for pawn item if was selected
                obj.item.calculateAuctionPrice = _.findIndex(that.checkedForCalculateAuctionPrice, {id: obj.item.id}) > -1;

                // calculate box number
                obj.item.boxNumber = obj.item.withdrawBox ? obj.item.withdrawBox.branchId + '-'
                  + obj.item.withdrawBox.boxNumber : null;

                // Extend item with category/type/subtype labels
                Object.assign(obj.item, {categoryLabel: that.getTypeLabel(obj.item.categoryId)});
                Object.assign(obj.item, {typeLabel: that.getTypeLabel(obj.item.typeId)});
                Object.assign(obj.item, {subtypeLabel: that.getTypeLabel(obj.item.subtypeId)});
                // Extend item with details pane data
                Object.assign(obj.item, {details: that.readItemDetails(obj.item)});
                if (!obj.pawn) {
                  Object.assign(obj.pawn, {
                    auctionDate: '-',
                    expirationDate: '-',
                    productNumber: '-'
                  });
                }
              })
            }
          });
      }
    });

    that.getSelectedAuctionIds = () => {
      if (that.hasAllAuctionsSelected()) {
        return that.auctions
          .filter(auction => auction.branchId === that.params.branchId)
          .map(auction => auction.id);
      }
      return that.params.pawnAuctionId;
    }

    that.hasAllAuctionsSelected = () => that.params.branchId && !_.first(that.params.pawnAuctionId);

    that.itemClicked = (item, $event) => {
      $event.stopPropagation();
      that.selectedItemId = item.id;
    };

    that.hideInlinePanel = () => {
      that.selectedItemId = null;
    };

    that.readItemDetails = (item) => {
      return pawnService.buildDescription(item, that.pawnItemDefectTypes, that.pawnItemTypes, that.metals, that.pawnItemAttributeTypes, that.pawnMetalRates);
    };

    that.checkCalculateAuctionPrice = (item) => {
      if (item.calculateAuctionPrice) {
        that.checkedForCalculateAuctionPrice.push(item);
      } else {
        const idx = _.findIndex(that.checkedForCalculateAuctionPrice, {id: item.id});
        if (idx > -1) {
          that.checkedForCalculateAuctionPrice.splice(idx, 1);
        }
      }
    };

    that.calculateAuctionPriceAll = () => {
      _.forEach(that.tableConfig.data, obj => {
        const item = obj.item;
        if (obj.pawn.status !== 'AUCTIONED') {
          return;
        }

        const idx = _.findIndex(that.checkedForCalculateAuctionPrice, {id: item.id});
        if (that.chkCalculateAuctionPriceAll && idx === -1) {
          // tick all and current item is not ticked
          that.checkedForCalculateAuctionPrice.push(item);
          item.calculateAuctionPrice = true;
        } else if (!that.chkCalculateAuctionPriceAll && idx > -1) {
          // untick all and current item is ticked
          that.checkedForCalculateAuctionPrice.splice(idx, 1);
          item.calculateAuctionPrice = false;
        }
      });
    };

    that.checkWithdraw = (item) => {
      if (item.withdraw) {
        that.checkedForWithdraw.push(item);
      } else {
        const idx = _.findIndex(that.checkedForWithdraw, {id: item.id});
        if (idx > -1) {
          that.checkedForWithdraw.splice(idx, 1);
        }
      }
    };

    that.withdrawAll = () => {
      _.forEach(that.tableConfig.data, obj => {
        const item = obj.item;
        const eligibleForWithdrawal = item.status === 'PAWNED_EXPIRED' || obj.pawn.productStatus === 'AUCTIONED';
        const idx = _.findIndex(that.checkedForWithdraw, {id: item.id});

        if (that.chkWithdrawAll && eligibleForWithdrawal) {
          item.withdraw = true;

          if (idx === -1) {
            that.checkedForWithdraw.push(item);
          }
        } else {
          item.withdraw = false;

          if (idx > -1) {
            that.checkedForWithdraw.splice(idx, 1);
          }
        }
      });
    };

    that.checkMoveToStock = (item) => {
      if (item.moveToStock) {
        that.checkedForMoveToStock.push(item);
      } else {
        const idx = _.findIndex(that.checkedForMoveToStock, {id: item.id});
        if (idx !== -1) {
          that.checkedForMoveToStock.splice(idx, 1);
        }
      }
    }

    that.checkMoveToStockAll = () => {
      _.forEach(that.tableConfig.data, obj => {
        const item = obj.item;
        if (obj.pawn.status !== 'AUCTIONED' && obj.pawn.productStatus !== 'AUCTIONED') {
          return;
        }

        const idx = _.findIndex(that.checkedForMoveToStock, {id: item.id});
        if (that.chkMoveToStockAll) {
          if (idx === -1 && (obj.pawn.status === 'AUCTIONED' || obj.pawn.productStatus === 'AUCTIONED')) {
            item.moveToStock = true;
            that.checkedForMoveToStock.push(item);
          }
        } else {
          item.moveToStock = false;

          if (idx !== -1) {
            that.checkedForMoveToStock.splice(idx, 1);
          }
        }
      });
    }

    that.moveToStockedItemAction = () => {
      let content = [];

      that.checkedForMoveToStock.forEach(item => {
        const pawn = that.result.find(obj => obj.item.id = item.id)
        content.push({label: 'PT Number', value: pawn.productNumber});
      });

      const buttons = [{
        text: 'Move to Stock',
        action: async () => {
          modalInfo.closeModalWithBackdrop();
          const res = await command.execute('MoveAuctionedPawnItemsToStock', {itemIds: that.checkedForMoveToStock.map(item => item.id) }).toPromise();
          if (!res || res.approvalRequired) {
            return;
          }

          pawnItemCache.evict();
          pawnCache.evict();

          popup({
            text: 'Pawn items have been moved to stock.',
            callback: () => {
              $route.reload();
            }
          });
        },
        bclass: 'btn btn-primary'
      }];

      modalInfo.display(
        content,
        "Pawned items selected to move to stock",
        `Do you want to move ${that.checkedForMoveToStock.length} items to stock?`,
        buttons);
    }

    that.getAuctionNamesForCurrentBranch = () => {
      const auctions = _.filter(that.auctions, a => that.selectedAuctionIds.includes(a.id))
      return auctions != null ? auctions.map(a => a.name).join(", ") : null;
    }

    that.withdrawAction = () => {
      const branch = _.find(that.branches, {id: that.currentBranchId});
      const branchName = branch != null ? branch.name : null;
      const auctionsName = that.getAuctionNamesForCurrentBranch();

      const content = pawnMetalDescriptionService.buildSelectedItemsInfo(
        branchName,
        auctionsName,
        that.checkedForWithdraw
      );

      const buttons = [{
        text: 'Withdraw',
        action: async () => {
          modalInfo.closeModalWithBackdrop();

          const res = await command.execute('WithdrawPawnItem', {itemIds: that.checkedForWithdraw.map(el => el.id)}).toPromise();
          if (!res || res.approvalRequired) {
            return;
          }

          pawnItemCache.evict();
          pawnCache.evict();

          popup({
            text: `Created box number: ${branch.id + '-' + res.output.id}`,
            callback: () => {
              $route.reload();
            }
          });
        },
        bclass: 'btn btn-primary'
      }];

      modalInfo.display(
        content,
        "Pawned items selected for withdraw",
        `Do you want to withdraw ${that.checkedForWithdraw.length} items to head office?`,
        buttons);
    };

    that.viewSelected = () => {
      const branch = _.find(that.branches, {id: that.currentBranchId});
      const branchName = branch != null ? branch.name : null;
      const auctionsName = that.getAuctionNamesForCurrentBranch();

      const content = pawnMetalDescriptionService.buildSelectedItemsInfo(
        branchName,
        auctionsName,
        [...that.checkedForWithdraw]);

      modalInfo.display(content, "Selected pawned items");
    };

    that.viewCalculateAuctionPricePage = () => {
      const selectedBranchId = that.params.branchId;
      const selectedIds = that.checkedForCalculateAuctionPrice.map(item => item.id);
      let target = `/dashboard/appraisals/auction-price/calculate`;
      $location.path(target).search({
        selectedIds : selectedIds,
        selectedBranchId: selectedBranchId
      });
    };

    that.remove = (item) => {
      confirmation('Do you want to removed the item?', () => {
        http.put(`/products/pawns/items/${item.id}/status`, '"CANCELLED"')
          .success(() => {
            notification.show("Success", "Item successfully removed");
            that.filter();
          })
          .error(() => {
            notification.show("Error", "Failed to remove item");
          });
      })
    };
  }
});
